module.exports = __webpack_public_path__ + "e3ccd188fbd9dc022d84d23a0a80d42a.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/yzslogo.png
// module id = 1322
// module chunks = 61